import { useState } from "react";
import TableHead from "../../../../components/UI/TableUI/TableHead";
import { discardedCyHeadList } from "../../../../utils/TableHeadList";
import NoDataDisplay from "../../../../components/UI/NoDataDisplay";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import FilterSearch from "../../../../components/common/FilterSearch";
import { discardedCylinderSearch } from "../../../../utils/tableSearchList";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import ActiveCylinderDialog from "./ActiveCylinderDialog";

const DiscardedList = ({ cylinders }) => {
  const [selectedCylinder, setSelectedCylinder] = useState(null);
  const isDataAvailable = cylinders.length > 0;

  const { checkPermission } = UsePermissionsClaim();
  const permActive = checkPermission("re_active_cylinder");

  let filterHeadList = discardedCyHeadList;

  if (!permActive) {
    filterHeadList = discardedCyHeadList.filter((i) => i.title !== "Action");
  }

  return (
    <>
      <MobileActionHeader title="Discarded Cylinders" />
      <FilterSearch searchCategories={discardedCylinderSearch} />
      <div className={`table-container table-height`}>
        <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
          <tbody>
            <TableHead headList={filterHeadList} />
            {isDataAvailable ? (
              <>
                {cylinders.map((cy, index) => {
                  return (
                    <tr className="table-row [&_td]:p-3" key={index}>
                      <td>{cy.serialNo}</td>
                      <td>{cy.size}KG</td>
                      <td>{cy.reasonForDiscard}</td>
                      <td>{cy.checkpointDetail?.updatedBy.fullName}</td>
                      <td>{formatDate(cy.checkpointDetail?.updatedAt)}</td>
                      {permActive && (
                        <td>
                          <button
                            className="bg-teal-600 hover:bg-teal-500 px-4 py-[3px] text-white rounded-lg text-sm hover:text-white transition"
                            onClick={() =>
                              setSelectedCylinder({
                                cylinderNo: cy.serialNo,
                                cylinderId: cy.id,
                                reason: cy.reasonForDiscard,
                              })
                            }
                          >
                            Enable
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </>
            ) : (
              <NoDataDisplay />
            )}
          </tbody>
        </table>
      </div>
      {selectedCylinder && (
        <ActiveCylinderDialog
          setSelectedCylinder={setSelectedCylinder}
          cylinderDetails={selectedCylinder}
        />
      )}
    </>
  );
};
export default DiscardedList;
